import { initializeCarousel } from './carousel.js';

let element;

//Events when navigation back
window.addEventListener('popstate', function (e) {
   var page = e.state;
   //closeAjaxContainer();
   if (page == null) {
   } else {
      //close active open window
     // closeAjaxContainer();

      //Get the URL from the state object
      var url = page;
      insertPageContainer(url, element);

    }
});


const insertPageContainer = function (url, element) {

  const navMain = document.querySelector('.nav-main__menu');
  const navMainToggle = document.querySelector('.nav-main__icon');

   var currentUrl = window.location.href;
   // Find the index of the first occurrence of :// in the URL
   var index = currentUrl.indexOf('://');

   // Remove the protocol from the URL
   var urlWithoutProtocol = currentUrl.substring(index + 1);
   var pageMain = document.querySelector('main');

   console.log(url);
   console.log(urlWithoutProtocol);

   if (url !== urlWithoutProtocol) {
       // 'url' is not the current page URL
       console.log("The URL is not the same as the current page URL.");
       navMain.classList.remove('is-open');
       navMainToggle.classList.remove('is-open');
   } else {
      // 'url' is the current page URL, do nothing
      navMain.classList.remove('is-open');
      navMainToggle.classList.remove('is-open');
      return;


   }

   var pageSlug = element.getAttribute('data-page');

    element.classList.add('disabled');


      //Add color
      // Select all elements with the class 'nav-link'
      const navLinks = document.querySelectorAll('.nav-link');

      // Loop through each element and remove the 'active' class
      navLinks.forEach(navLink => {
        navLink.classList.remove('active');
      });
      //Set class to active
      element.classList.add('active');

      //Set Global Color by setting a body attr (for other elements);
      const body = document.querySelector('body');
      body.setAttribute('data-page', pageSlug);




   const prevUrl = window.location.href;
    //find the parent


   //Fetch data
   fetch(url)
      .then(function (response) {
         //Get data as html/text
         return response.text();
      })
      .then(function (html) {
         //Fill the new container with content
         var parser = new DOMParser();
         var doc = parser.parseFromString(html, 'text/html');

         // Search for the div with class 'page-content'
         var pageContent = doc.querySelector('main');

         pageMain.innerHTML = pageContent.innerHTML;

        //remove and reset classname
         pageMain.className = '';
         pageMain.classList.add(pageSlug);

         //Re-Enable link
         element.classList.remove('disabled');

         //Set Window URL -- disable during dev
         if (window.location.href !== url) {
            history.pushState(url, null, url);
         }

         // Scroll to the top of the page
         window.scrollTo({ top: 0, behavior: 'smooth' });
         const carousels = document.querySelectorAll('.cascade-list');
         carousels.forEach(initializeCarousel);
      })
      .catch(function (err) {
         // There was an error
         console.warn('Something went wrong.', err);
      });
}; //insertPageContainer

document.addEventListener('click', (e) => {



   if (e.target.classList.contains('nav-link')) {

      e.preventDefault();
     element = e.target;
      const url = e.target.getAttribute('href');
      insertPageContainer(url, element);
   }
});

